/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { PfTvChart } from '@/screens/custom-elements';
import type { ViewModel } from './view-model';

export function TradeHubView({ m }: { m: ViewModel }) {
  return (
    <div
      style={{
        display: 'flex',
        gap: '12px',
        height: '100%',
        minHeight: '0',
        padding: '12px',
        boxSizing: 'border-box',
      }}
    >
      {' '}
      <div
        style={{
          flex: '1',
          minWidth: '0',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          overflowY: 'auto',
        }}
      >
        {' '}
        <section
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            display: 'flex',
            flexDirection: 'column',
            flex: '1 0 auto',
            height: 'auto',
            minHeight: '530px',
          }}
        >
          {' '}
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: '10px 18px',
              padding: '12px 16px',
              borderBottom: '1px solid var(--l6)',
              minWidth: '0',
            }}
          >
            {' '}
            <button
              onClick={m.thInstrumentGo}
              className="scp-4f3e86a"
              title={dc.s(m.deskSymTitle)}
              aria-label={dc.s(m.deskSymTitle)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '13px',
                fontWeight: '600',
                letterSpacing: '-0.01em',
                padding: '5px 12px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                background: 'transparent',
                color: 'var(--text)',
                cursor: 'pointer',
              }}
            >
              <i className="ph ph-magnifying-glass" style={{ fontSize: '12px', color: 'var(--faint)' }}></i>
              {dc.t(m.deskSym)}
              <i className="ph ph-caret-down" style={{ fontSize: '10px', color: 'var(--faint)' }}></i>
            </button>{' '}
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '9px' }}>
              {' '}
              <span
                style={dc.css(
                  `font-size:19px;font-weight:600;letter-spacing:-0.02em;font-variant-numeric:tabular-nums;color:${dc.s(m.ch?.chgCol)}`,
                )}
              >
                {dc.t(m.ch?.lastPrice)}
              </span>{' '}
              <span
                style={dc.css(
                  `font-size:11.5px;font-variant-numeric:tabular-nums;color:${dc.s(m.ch?.chgCol)}`,
                )}
              >
                {dc.t(m.ch?.chg)}
                {' ('}
                {dc.t(m.ch?.chgPct)})
              </span>{' '}
            </div>{' '}
            <div style={{ display: 'flex', gap: '16px' }}>
              {' '}
              <div>
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Bid
                </div>
                <div
                  style={{
                    fontSize: '12px',
                    fontVariantNumeric: 'tabular-nums',
                    color: 'var(--neg)',
                    marginTop: '2px',
                  }}
                >
                  {dc.t(m.ch?.bid)}
                </div>
              </div>{' '}
              <div>
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Ask
                </div>
                <div
                  style={{
                    fontSize: '12px',
                    fontVariantNumeric: 'tabular-nums',
                    color: 'var(--pos)',
                    marginTop: '2px',
                  }}
                >
                  {dc.t(m.ch?.ask)}
                </div>
              </div>{' '}
              <div>
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Spread
                </div>
                <div
                  style={{
                    fontSize: '12px',
                    fontVariantNumeric: 'tabular-nums',
                    color: 'var(--text2)',
                    marginTop: '2px',
                  }}
                >
                  {dc.t(m.ch?.spread)}
                </div>
              </div>{' '}
            </div>{' '}
            <div style={{ minWidth: '150px' }}>
              {' '}
              <div
                style={{
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                Day range
              </div>{' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '7px', marginTop: '5px' }}>
                {' '}
                <span style={{ fontSize: '10px', color: 'var(--faint)', fontVariantNumeric: 'tabular-nums' }}>
                  {dc.t(m.ch?.dayLo)}
                </span>{' '}
                <div
                  style={{
                    flex: '1',
                    height: '3px',
                    borderRadius: '99px',
                    background: 'var(--l6)',
                    position: 'relative',
                  }}
                >
                  <span
                    style={dc.css(
                      `position:absolute;top:-2px;left:${dc.s(m.ch?.rangePos)};width:2px;height:7px;border-radius:99px;background:var(--text-mid)`,
                    )}
                  ></span>
                </div>{' '}
                <span style={{ fontSize: '10px', color: 'var(--faint)', fontVariantNumeric: 'tabular-nums' }}>
                  {dc.t(m.ch?.dayHi)}
                </span>{' '}
              </div>{' '}
            </div>{' '}
            <div style={{ flex: '1' }}></div>{' '}
            <button
              onClick={m.thAcctToggle}
              aria-haspopup="true"
              aria-expanded={!!m.thAcctOpen}
              aria-label="Switch trading account"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '7px',
                fontSize: '11.5px',
                padding: '5px 12px',
                borderRadius: '99px',
                border: '1px solid var(--l8)',
                background: 'color-mix(in srgb, var(--pos) 7%, transparent)',
                color: 'var(--pos-2)',
                cursor: 'pointer',
              }}
            >
              {dc.t(m.thAcctLabel)}
              <i className="ph ph-caret-down" style={{ fontSize: '10px', color: 'var(--faint)' }}></i>
            </button>{' '}
          </div>{' '}
          <div
            style={{
              flex: '1',
              display: 'flex',
              minHeight: '340px',
              borderBottomLeftRadius: '16px',
              borderBottomRightRadius: '16px',
              overflow: 'hidden',
            }}
          >
            {' '}
            <PfTvChart
              symbol={dc.a(m.tvSym)}
              interval={dc.a(m.tvInterval)}
              theme={dc.a(m.tvTheme)}
              mode="trade"
              sl={dc.a(m.tvSl)}
              tp={dc.a(m.tvTp)}
              style={{ flex: '1', minWidth: '0', minHeight: '340px' }}
              slState={dc.a(m.tvSlState)}
              tpState={dc.a(m.tvTpState)}
              slLive={dc.a(m.tvSlLive)}
              tpLive={dc.a(m.tvTpLive)}
              slTrailing={dc.a(m.tvSlTrailing)}
              entry={dc.a(m.tvEntry)}
              side={dc.a(m.tvSide)}
            ></PfTvChart>{' '}
          </div>{' '}
        </section>{' '}
        <section
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            flex: 'none',
            overflow: 'hidden',
          }}
        >
          {' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '11px 16px' }}>
            {' '}
            <span style={{ fontSize: '12.5px', fontWeight: '500' }}>Positions & Orders</span>{' '}
            <span style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>{dc.t(m.posSectionLabel)}</span>{' '}
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 9px',
                borderRadius: '99px',
                border: '1px solid var(--l8)',
                color: 'var(--muted)',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {dc.t(m.posSummary)}
            </span>{' '}
            <div style={{ flex: '1' }}></div>{' '}
            <button
              className="scp-4f3e86a"
              onClick={m.posToggle}
              title={dc.a(m.posToggleLabel)}
              aria-label={dc.a(m.posToggleLabel)}
              aria-expanded={dc.b(m.posOpen)}
              style={{
                width: '26px',
                height: '26px',
                borderRadius: '9px',
                border: '1px solid var(--l8)',
                background: 'transparent',
                color: 'var(--faint)',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <i className={`ph ${dc.s(m.posToggleIcon)}`} style={{ fontSize: '13px' }}></i>
            </button>{' '}
          </div>{' '}
          {m.posOpen ? (
            <>
              {' '}
              <div>
                {' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    padding: '0 16px',
                    borderTop: '1px solid var(--l6)',
                    borderBottom: '1px solid var(--l6)',
                    minWidth: '0',
                  }}
                >
                  {' '}
                  {(m.posTabs ?? []).map((t, i44) => (
                    <Fragment key={i44}>
                      {' '}
                      <button
                        onClick={t?.go}
                        title={dc.a(t?.label)}
                        aria-label={dc.a(t?.label)}
                        style={dc.css(
                          `display:inline-flex;align-items:center;gap:6px;padding:9px 12px;border:none;border-bottom:2px solid ${dc.s(t?.bb)};background:transparent;color:${dc.s(t?.fg)};font-size:11.5px;font-weight:500;cursor:pointer;white-space:nowrap`,
                        )}
                      >
                        {dc.t(t?.label)}
                        <span
                          style={{
                            fontSize: '9.5px',
                            color: 'var(--muted2)',
                            fontVariantNumeric: 'tabular-nums',
                          }}
                        >
                          {dc.t(t?.count)}
                        </span>
                      </button>{' '}
                    </Fragment>
                  ))}{' '}
                  <div style={{ flex: '1' }}></div>{' '}
                  <div style={{ display: 'flex', gap: '18px', padding: '4px 0', flex: 'none' }}>
                    {' '}
                    <div>
                      <div
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        Balance
                      </div>
                      <div
                        style={{
                          fontSize: '11.5px',
                          color: 'var(--text2)',
                          fontVariantNumeric: 'tabular-nums',
                          marginTop: '2px',
                        }}
                      >
                        {dc.t(m.thBal)}
                      </div>
                    </div>{' '}
                    <div>
                      <div
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        P&L
                      </div>
                      <div
                        style={{
                          fontSize: '11.5px',
                          color: 'var(--text2)',
                          fontVariantNumeric: 'tabular-nums',
                          marginTop: '2px',
                        }}
                      >
                        {dc.t(m.thPnl)}
                      </div>
                    </div>{' '}
                    <div>
                      <div
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        Equity
                      </div>
                      <div
                        style={{
                          fontSize: '11.5px',
                          color: 'var(--text2)',
                          fontVariantNumeric: 'tabular-nums',
                          marginTop: '2px',
                        }}
                      >
                        {dc.t(m.thEquity)}
                      </div>
                    </div>{' '}
                    <div>
                      <div
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        Margin used
                      </div>
                      <div
                        style={{
                          fontSize: '11.5px',
                          color: 'var(--text2)',
                          fontVariantNumeric: 'tabular-nums',
                          marginTop: '2px',
                        }}
                      >
                        –
                      </div>
                    </div>{' '}
                  </div>{' '}
                </div>{' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '9px 16px',
                    borderBottom: '1px solid var(--l5)',
                  }}
                >
                  {' '}
                  <input
                    placeholder="Filter symbol…"
                    aria-label="Filter by symbol"
                    value={String(m.posFilterSym ?? '')}
                    onChange={(e) => m.posFilterSet?.(e.target.value)}
                    style={{
                      width: '130px',
                      padding: '5px 12px',
                      borderRadius: '99px',
                      border: '1px solid var(--l10)',
                      background: 'transparent',
                      color: 'var(--text)',
                      fontSize: '11px',
                      outline: 'none',
                    }}
                  />{' '}
                  <button
                    disabled
                    className="scp-4f3e86a"
                    aria-describedby="pf-desk-daterange-note"
                    title="Desk rows in this build carry no dates to filter by — the dated Trades screen has the range filter; this control activates with the dated desk ledger."
                    aria-label="Filter by date range (not available in this build)"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '11px',
                      padding: '5px 12px',
                      borderRadius: '99px',
                      border: '1px solid var(--l10)',
                      background: 'transparent',
                      color: 'var(--muted)',
                      cursor: 'pointer',
                    }}
                  >
                    <i className="ph ph-calendar-blank" style={{ fontSize: '12px' }}></i>Last 30 days
                  </button>{' '}
                  <div style={{ flex: '1' }}></div>{' '}
                  <button
                    onClick={m.posExportCsv}
                    className="scp-4f3e86a"
                    title="Export to CSV"
                    aria-label="Export to CSV"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '11px',
                      padding: '5px 12px',
                      borderRadius: '99px',
                      border: '1px solid var(--l10)',
                      background: 'transparent',
                      color: 'var(--muted)',
                      cursor: 'pointer',
                    }}
                  >
                    <i className="ph ph-download-simple" style={{ fontSize: '12px' }}></i>Export
                  </button>{' '}
                  {m.posBeShow ? (
                    <>
                      {' '}
                      <button
                        className="scp-f8cf2da"
                        onClick={m.posBeAll}
                        title={dc.a(m.posBeTitle)}
                        aria-label={dc.a(m.posBeTitle)}
                        style={dc.css(
                          `display:inline-flex;align-items:center;gap:6px;font-size:11px;padding:5px 12px;border-radius:99px;border:1px solid color-mix(in srgb, var(--pos) 40%, transparent);background:transparent;color:var(--pos);cursor:pointer;opacity:${dc.s(m.posBeOp)}`,
                        )}
                      >
                        <i className="ph ph-shield-check" style={{ fontSize: '12px' }}></i>
                        {dc.t(m.posBeCount)}
                      </button>{' '}
                    </>
                  ) : null}{' '}
                  <button
                    onClick={m.posCloseAllAsk}
                    disabled={m.posBusy === 'closeAll'}
                    className="scp-b8ab6d8"
                    title="Close all positions"
                    aria-label="Close all positions"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '11px',
                      padding: '5px 12px',
                      borderRadius: '99px',
                      border: '1px solid color-mix(in srgb, var(--neg) 40%, transparent)',
                      background: 'transparent',
                      color: 'var(--neg)',
                      cursor: 'pointer',
                    }}
                  >
                    <i className="ph ph-x-circle" style={{ fontSize: '12px' }}></i>Close all
                  </button>{' '}
                </div>{' '}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1.2fr 0.9fr 0.7fr 1fr 1fr 0.8fr 0.8fr 0.9fr 0.7fr',
                    gap: '12px',
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                    padding: '8px 16px',
                    borderBottom: '1px solid var(--l5)',
                  }}
                >
                  <span>Symbol</span>
                  <span>Type</span>
                  <span>Volume</span>
                  <span>Open</span>
                  <span>Current</span>
                  <span>SL</span>
                  <span>TP</span>
                  <span style={{ textAlign: 'right' }}>P&L</span>
                  <span style={{ textAlign: 'right' }}>Actions</span>
                </div>{' '}
                {m.posHasRows ? (
                  <>
                    {' '}
                    <div>
                      {' '}
                      {(m.posRows ?? []).map((r, i45) => (
                        <Fragment key={i45}>
                          {' '}
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '1.2fr 0.9fr 0.7fr 1fr 1fr 0.8fr 0.8fr 0.9fr 0.7fr',
                              gap: '12px',
                              alignItems: 'center',
                              fontSize: '11.5px',
                              padding: '9px 16px',
                              borderBottom: '1px solid var(--l5)',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {' '}
                            <span style={{ fontWeight: '500' }}>{dc.t(r?.sym)}</span>{' '}
                            <span style={{ color: 'var(--muted)', fontSize: '10.5px' }}>{dc.t(r?.type)}</span>{' '}
                            <span style={{ color: 'var(--text2)' }}>{dc.t(r?.vol)}</span>{' '}
                            <span style={{ color: 'var(--text2)' }}>{dc.t(r?.open)}</span>{' '}
                            <span style={{ color: 'var(--text2)' }}>{dc.t(r?.cur)}</span>{' '}
                            <span
                              style={dc.css(
                                `color:${dc.s(r?.slFg)};display:inline-flex;align-items:center;gap:5px`,
                              )}
                            >
                              {dc.t(r?.sl)}
                              {r?.atBe ? (
                                <span
                                  style={{
                                    fontSize: '8.5px',
                                    fontWeight: '700',
                                    letterSpacing: '0.06em',
                                    padding: '1px 5px',
                                    borderRadius: '99px',
                                    background: 'color-mix(in srgb, var(--pos) 14%, transparent)',
                                    color: 'var(--pos)',
                                  }}
                                >
                                  BE
                                </span>
                              ) : null}
                            </span>{' '}
                            <span style={{ color: 'var(--muted2)' }}>{dc.t(r?.tp)}</span>{' '}
                            <span style={dc.css(`text-align:right;font-weight:600;color:${dc.s(r?.pnlFg)}`)}>
                              {dc.t(r?.pnl)}
                            </span>{' '}
                            <span
                              style={{
                                display: 'flex',
                                gap: '4px',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                              }}
                            >
                              {' '}
                              {r?.hasBe ? (
                                <>
                                  {' '}
                                  <button
                                    className="scp-f8cf2da"
                                    onClick={r?.be?.go}
                                    title={dc.a(r?.be?.title)}
                                    aria-label={dc.a(r?.be?.title)}
                                    style={dc.css(
                                      `font-size:9.5px;font-weight:600;padding:3px 8px;border-radius:99px;border:1px solid ${dc.s(r?.be?.bd)};background:transparent;color:${dc.s(r?.be?.fg)};cursor:pointer;white-space:nowrap;opacity:${dc.s(r?.be?.op)}`,
                                    )}
                                  >
                                    {dc.t(r?.be?.label)}
                                  </button>{' '}
                                </>
                              ) : null}{' '}
                              <button
                                className="scp-4f3e86a"
                                onClick={r?.modify}
                                disabled={!!r?.actBusy}
                                title="Modify"
                                aria-label={`Modify ${dc.s(r?.sym)}`}
                                style={dc.css(
                                  `width:24px;height:24px;border-radius:8px;border:none;background:transparent;color:var(--faint);cursor:pointer;opacity:${r?.actBusy ? '0.45' : '1'}`,
                                )}
                              >
                                <i className="ph ph-pencil-simple" style={{ fontSize: '12px' }}></i>
                              </button>{' '}
                              <button
                                className="scp-4f3e86a"
                                onClick={r?.close}
                                disabled={!!r?.actBusy}
                                title="Close"
                                aria-label={`Close ${dc.s(r?.sym)}`}
                                style={dc.css(
                                  `width:24px;height:24px;border-radius:8px;border:none;background:transparent;color:var(--faint);cursor:pointer;opacity:${r?.actBusy ? '0.45' : '1'}`,
                                )}
                              >
                                <i className="ph ph-x" style={{ fontSize: '12px' }}></i>
                              </button>{' '}
                            </span>{' '}
                          </div>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                  </>
                ) : null}{' '}
                {m.posNoRows ? (
                  <>
                    {' '}
                    <div
                      style={{
                        padding: '22px',
                        textAlign: 'center',
                        fontSize: '11.5px',
                        color: 'var(--faint)',
                      }}
                    >
                      {dc.t(m.posEmpty)}
                    </div>{' '}
                  </>
                ) : null}{' '}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 16px' }}>
                  {' '}
                  <span
                    style={{ fontSize: '10.5px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}
                  >
                    {dc.t(m.posPager)}
                  </span>{' '}
                  <div style={{ flex: '1' }}></div>{' '}
                  <button
                    onClick={m.posPagePrev}
                    className="scp-4f3e86a"
                    title="Previous page"
                    aria-label="Previous page"
                    style={{
                      width: '26px',
                      height: '26px',
                      borderRadius: '9px',
                      border: '1px solid var(--l8)',
                      background: 'transparent',
                      color: 'var(--faint)',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <i className="ph ph-caret-left" style={{ fontSize: '12px' }}></i>
                  </button>{' '}
                  <button
                    onClick={m.posPageNext}
                    className="scp-4f3e86a"
                    title="Next page"
                    aria-label="Next page"
                    style={{
                      width: '26px',
                      height: '26px',
                      borderRadius: '9px',
                      border: '1px solid var(--l8)',
                      background: 'transparent',
                      color: 'var(--faint)',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <i className="ph ph-caret-right" style={{ fontSize: '12px' }}></i>
                  </button>{' '}
                </div>{' '}
              </div>{' '}
            </>
          ) : null}{' '}
        </section>{' '}
      </div>{' '}
      <aside
        style={dc.css(
          `background:var(--surface);border:1px solid var(--card-line);box-shadow:var(--shadow-card);border-radius:16px;width:${dc.s(m.sideWidth)};flex:none;display:flex;flex-direction:column;overflow:hidden`,
        )}
      >
        {' '}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '11px 12px',
            borderBottom: '1px solid var(--l6)',
          }}
        >
          {' '}
          {m.sideOpen ? (
            <>
              {' '}
              <span style={{ fontSize: '12.5px', fontWeight: '500', flex: '1' }}>Order Desk</span>{' '}
            </>
          ) : null}{' '}
          <button
            className="scp-e5d0807"
            onClick={m.sideToggle}
            title={dc.a(m.sideToggleLabel)}
            aria-label={dc.a(m.sideToggleLabel)}
            aria-expanded={dc.b(m.sideOpen)}
            style={{
              width: '26px',
              height: '26px',
              borderRadius: '9px',
              border: 'none',
              background: 'transparent',
              color: 'var(--faint)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
            }}
          >
            <i className={`ph ${dc.s(m.sideToggleIcon)}`} style={{ fontSize: '14px' }}></i>
          </button>{' '}
        </div>{' '}
        {m.sideClosed ? (
          <>
            {' '}
            <div
              className="pf-in"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '6px',
                padding: '10px 0',
              }}
            >
              {' '}
              <button
                className="scp-4f3e86a"
                onClick={m.sideToggle}
                title="Instruments"
                aria-label="Show instruments"
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '9px',
                  border: '1px solid var(--l8)',
                  background: 'transparent',
                  color: 'var(--faint)',
                  cursor: 'pointer',
                }}
              >
                <i className="ph ph-list-dashes" style={{ fontSize: '14px' }}></i>
              </button>{' '}
              <button
                className="scp-4f3e86a"
                onClick={m.sideToggle}
                title="Symbol filter"
                aria-label="Show symbol filter"
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '9px',
                  border: '1px solid var(--l8)',
                  background: 'transparent',
                  color: 'var(--faint)',
                  cursor: 'pointer',
                }}
              >
                <i className="ph ph-funnel" style={{ fontSize: '14px' }}></i>
              </button>{' '}
              <button
                className="scp-4f3e86a"
                onClick={m.sideToggle}
                title="Order ticket"
                aria-label="Show order ticket"
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '9px',
                  border: '1px solid var(--l8)',
                  background: 'transparent',
                  color: 'var(--faint)',
                  cursor: 'pointer',
                }}
              >
                <i className="ph ph-calculator" style={{ fontSize: '14px' }}></i>
              </button>{' '}
            </div>{' '}
          </>
        ) : null}{' '}
        {m.sideOpen ? (
          <>
            {' '}
            <div className="pf-in" style={{ flex: '1', minHeight: '0', overflowY: 'auto' }}>
              {' '}
              <div style={{ padding: '12px 14px', borderBottom: '1px solid var(--l6)' }}>
                {' '}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span
                    style={{
                      fontSize: '9px',
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                      color: 'var(--muted2)',
                      fontWeight: '600',
                    }}
                  >
                    Symbol filter
                  </span>
                  <div style={{ flex: '1' }}></div>
                  <span
                    style={{ fontSize: '9.5px', color: 'var(--faint)', fontVariantNumeric: 'tabular-nums' }}
                  >
                    {dc.t(m.deskCount)}
                  </span>
                </div>{' '}
                <div style={{ display: 'flex', alignItems: 'center', gap: '7px', marginTop: '9px' }}>
                  {' '}
                  <div
                    style={{
                      flex: '1',
                      minWidth: '0',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '7px',
                      padding: '5px 11px',
                      borderRadius: '99px',
                      border: '1px solid var(--l10)',
                    }}
                  >
                    {' '}
                    <i
                      className="ph ph-magnifying-glass"
                      style={{ fontSize: '11px', color: 'var(--faint)', flex: 'none' }}
                    ></i>{' '}
                    <input
                      value={dc.v(m.deskQ)}
                      onChange={m.setDeskQ}
                      placeholder="Search symbols…"
                      aria-label="Search symbols"
                      style={{
                        flex: '1',
                        minWidth: '0',
                        border: 'none',
                        background: 'transparent',
                        color: 'var(--text)',
                        fontSize: '11px',
                        outline: 'none',
                      }}
                    />{' '}
                  </div>{' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={m.deskFavOnly?.go}
                    aria-pressed={dc.b(m.deskFavOnly?.on)}
                    title={dc.a(m.deskFavOnly?.title)}
                    aria-label={dc.a(m.deskFavOnly?.title)}
                    style={dc.css(
                      `display:inline-flex;align-items:center;gap:5px;flex:none;font-size:10.5px;font-weight:${dc.s(m.deskFavOnly?.fw)};padding:5px 10px;border-radius:99px;border:1px solid ${dc.s(m.deskFavOnly?.bd)};background:${dc.s(m.deskFavOnly?.bg)};color:${dc.s(m.deskFavOnly?.fg)};cursor:pointer`,
                    )}
                  >
                    <i className={`ph ${dc.s(m.deskFavOnly?.icon)}`} style={{ fontSize: '11px' }}></i>
                    Favourites
                  </button>{' '}
                </div>{' '}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '16px 1fr auto auto auto',
                    gap: '4px 10px',
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                    marginTop: '11px',
                  }}
                >
                  <span></span>
                  <span>Instrument</span>
                  <span>Bid</span>
                  <span>Ask</span>
                  <span>Sprd</span>
                </div>{' '}
                {(m.deskSyms ?? []).map((s, i46) => (
                  <Fragment key={i46}>
                    {' '}
                    <div
                      style={dc.css(
                        `display:grid;grid-template-columns:16px 1fr auto auto auto;gap:4px 10px;align-items:center;font-size:11.5px;padding:6px 0;border-bottom:1px solid var(--l5);background:${dc.s(s?.rowBg)}`,
                      )}
                    >
                      {' '}
                      <button
                        onClick={s?.star}
                        aria-pressed={dc.b(s?.fav)}
                        title={dc.a(s?.starLabel)}
                        aria-label={dc.a(s?.starLabel)}
                        style={dc.css(
                          `width:16px;height:16px;padding:0;border:none;background:transparent;color:${dc.s(s?.starFg)};cursor:pointer;display:flex;align-items:center;justify-content:center`,
                        )}
                      >
                        <i className={`ph ${dc.s(s?.starIcon)}`} style={{ fontSize: '12px' }}></i>
                      </button>{' '}
                      <button
                        onClick={s?.pick}
                        aria-label={`Load ${dc.s(s?.sym)}`}
                        style={dc.css(
                          `border:none;background:transparent;padding:0;text-align:left;font-size:11.5px;font-weight:${dc.s(s?.fw)};color:var(--text);cursor:pointer`,
                        )}
                      >
                        {dc.t(s?.sym)}
                      </button>{' '}
                      <span style={{ color: 'var(--neg)', fontVariantNumeric: 'tabular-nums' }}>
                        {dc.t(s?.bid)}
                      </span>{' '}
                      <span style={{ color: 'var(--pos)', fontVariantNumeric: 'tabular-nums' }}>
                        {dc.t(s?.ask)}
                      </span>{' '}
                      <span style={{ color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}>
                        {dc.t(s?.spread)}
                      </span>{' '}
                    </div>{' '}
                  </Fragment>
                ))}{' '}
                {m.deskEmpty ? (
                  <>
                    {' '}
                    <div
                      style={{
                        fontSize: '11px',
                        color: 'var(--faint)',
                        padding: '12px 0 2px',
                        textAlign: 'center',
                      }}
                    >
                      {dc.t(m.deskEmptyMsg)}
                    </div>{' '}
                  </>
                ) : null}{' '}
                <button
                  onClick={m.deskAddToggle}
                  className="scp-b962371"
                  title="Add symbol"
                  aria-label="Add symbol"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    border: 'none',
                    background: 'transparent',
                    color: 'var(--faint)',
                    fontSize: '11px',
                    cursor: 'pointer',
                    padding: '9px 0 0',
                  }}
                >
                  <i className="ph ph-plus" style={{ fontSize: '11px' }}></i>Add symbol
                </button>{' '}
              </div>{' '}
              <div style={{ padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {' '}
                <div style={{ display: 'flex', borderBottom: '1px solid var(--l6)' }}>
                  {' '}
                  {(m.ticketTabs ?? []).map((t, i47) => (
                    <Fragment key={i47}>
                      {' '}
                      <button
                        onClick={t?.go}
                        title={dc.a(t?.label)}
                        aria-label={dc.a(t?.label)}
                        style={dc.css(
                          `padding:7px 12px;border:none;border-bottom:2px solid ${dc.s(t?.bb)};background:transparent;color:${dc.s(t?.fg)};font-size:11.5px;font-weight:500;cursor:pointer`,
                        )}
                      >
                        {dc.t(t?.label)}
                      </button>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                  {' '}
                  <button
                    className="scp-510ff13"
                    onClick={m.setSell}
                    title="Sell at bid"
                    aria-label="Sell at bid"
                    aria-pressed={dc.b(m.ordSell)}
                    style={dc.css(
                      `padding:9px 4px;border-radius:11px;border:1px solid ${dc.s(m.sellBd)};background:${dc.s(m.sellBg)};color:${dc.s(m.sellFg)};cursor:pointer;text-align:center`,
                    )}
                  >
                    <div
                      style={{ fontSize: '9px', letterSpacing: '0.11em', fontWeight: '600', opacity: '0.85' }}
                    >
                      SELL
                    </div>
                    <div
                      style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        fontVariantNumeric: 'tabular-nums',
                        marginTop: '2px',
                      }}
                    >
                      {dc.t(m.ch?.bid)}
                    </div>
                  </button>{' '}
                  <button
                    className="scp-510ff13"
                    onClick={m.setBuy}
                    title="Buy at ask"
                    aria-label="Buy at ask"
                    aria-pressed={dc.b(m.ordBuy)}
                    style={dc.css(
                      `padding:9px 4px;border-radius:11px;border:1px solid ${dc.s(m.buyBd)};background:${dc.s(m.buyBg)};color:${dc.s(m.buyFg)};cursor:pointer;text-align:center`,
                    )}
                  >
                    <div
                      style={{ fontSize: '9px', letterSpacing: '0.11em', fontWeight: '600', opacity: '0.85' }}
                    >
                      BUY
                    </div>
                    <div
                      style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        fontVariantNumeric: 'tabular-nums',
                        marginTop: '2px',
                      }}
                    >
                      {dc.t(m.ch?.ask)}
                    </div>
                  </button>{' '}
                </div>{' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    border: '1px solid var(--l8)',
                    borderRadius: '11px',
                    padding: '5px 8px',
                    background: 'var(--l3)',
                  }}
                >
                  {' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={m.lotsDown}
                    title="Decrease lot size"
                    aria-label="Decrease lot size"
                    style={{
                      width: '26px',
                      height: '26px',
                      flex: 'none',
                      borderRadius: '9px',
                      border: '1px solid var(--l8)',
                      background: 'transparent',
                      color: 'var(--text-mid)',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <i className="ph ph-minus" style={{ fontSize: '12px' }}></i>
                  </button>{' '}
                  <div style={{ flex: '1', minWidth: '0', textAlign: 'center' }}>
                    {' '}
                    <input
                      value={dc.v(m.ordLots)}
                      onChange={m.setOrdLots}
                      aria-label="Lot size"
                      style={{
                        width: '100%',
                        border: 'none',
                        background: 'transparent',
                        color: 'var(--text)',
                        fontSize: '13px',
                        fontWeight: '600',
                        textAlign: 'center',
                        outline: 'none',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    />{' '}
                    <div
                      style={{
                        fontSize: '9px',
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      {'lots · '}
                      {dc.t(m.ordNotional)}
                    </div>{' '}
                  </div>{' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={m.lotsUp}
                    title="Increase lot size"
                    aria-label="Increase lot size"
                    style={{
                      width: '26px',
                      height: '26px',
                      flex: 'none',
                      borderRadius: '9px',
                      border: '1px solid var(--l8)',
                      background: 'transparent',
                      color: 'var(--text-mid)',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <i className="ph ph-plus" style={{ fontSize: '12px' }}></i>
                  </button>{' '}
                </div>{' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {' '}
                  <div style={dc.css(`border:1px solid ${dc.s(m.slBd)};border-radius:11px;overflow:hidden`)}>
                    {' '}
                    <button
                      onClick={m.slToggle}
                      aria-pressed={dc.b(m.ordSlOn)}
                      aria-label={dc.a(m.slToggleLabel)}
                      style={dc.css(
                        `display:flex;align-items:center;gap:8px;width:100%;padding:7px 10px;border:none;background:${dc.s(m.slHeadBg)};color:${dc.s(m.slHeadFg)};cursor:pointer;text-align:left`,
                      )}
                    >
                      {' '}
                      <span
                        style={dc.css(
                          `width:14px;height:14px;border-radius:4px;border:1px solid ${dc.s(m.slBoxBd)};background:${dc.s(m.slBoxBg)};display:flex;align-items:center;justify-content:center;flex:none`,
                        )}
                      >
                        <i
                          className={`ph ${dc.s(m.slBoxIcon)}`}
                          style={{ fontSize: '10px', color: 'var(--rail-ink)' }}
                        ></i>
                      </span>{' '}
                      <span style={{ flex: '1', fontSize: '11.5px', fontWeight: '600' }}>Stop Loss</span>{' '}
                      <span style={{ fontSize: '9.5px', opacity: '0.8' }}>{dc.t(m.slHint)}</span>{' '}
                    </button>{' '}
                    {m.ordSlOn ? (
                      <>
                        {' '}
                        <div
                          style={{
                            padding: '8px 10px 9px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '6px',
                          }}
                        >
                          {' '}
                          <input
                            value={dc.v(m.ordSl)}
                            onChange={m.setOrdSl}
                            aria-label="Stop loss price"
                            style={{
                              width: '100%',
                              boxSizing: 'border-box',
                              padding: '7px 11px',
                              borderRadius: '9px',
                              border: '1px solid var(--l10)',
                              background: 'var(--fill)',
                              color: 'var(--text)',
                              fontSize: '12.5px',
                              outline: 'none',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          />{' '}
                          <div style={{ display: 'flex', gap: '12px' }}>
                            {' '}
                            <span style={{ fontSize: '10px', color: 'var(--muted2)', flex: '1' }}>
                              {'Distance '}
                              <span style={{ color: 'var(--text2)', fontVariantNumeric: 'tabular-nums' }}>
                                {dc.t(m.slDist)}
                              </span>
                            </span>{' '}
                            <span style={{ fontSize: '10px', color: 'var(--muted2)' }}>
                              {'Loss '}
                              <span
                                style={{
                                  color: 'var(--neg)',
                                  fontWeight: '600',
                                  fontVariantNumeric: 'tabular-nums',
                                }}
                              >
                                {dc.t(m.slLoss)}
                              </span>
                            </span>{' '}
                          </div>{' '}
                        </div>{' '}
                      </>
                    ) : null}{' '}
                  </div>{' '}
                  <div style={dc.css(`border:1px solid ${dc.s(m.tpBd)};border-radius:11px;overflow:hidden`)}>
                    {' '}
                    <button
                      onClick={m.tpToggle}
                      aria-pressed={dc.b(m.ordTpOn)}
                      aria-label={dc.a(m.tpToggleLabel)}
                      style={dc.css(
                        `display:flex;align-items:center;gap:8px;width:100%;padding:7px 10px;border:none;background:${dc.s(m.tpHeadBg)};color:${dc.s(m.tpHeadFg)};cursor:pointer;text-align:left`,
                      )}
                    >
                      {' '}
                      <span
                        style={dc.css(
                          `width:14px;height:14px;border-radius:4px;border:1px solid ${dc.s(m.tpBoxBd)};background:${dc.s(m.tpBoxBg)};display:flex;align-items:center;justify-content:center;flex:none`,
                        )}
                      >
                        <i
                          className={`ph ${dc.s(m.tpBoxIcon)}`}
                          style={{ fontSize: '10px', color: 'var(--rail-ink)' }}
                        ></i>
                      </span>{' '}
                      <span style={{ flex: '1', fontSize: '11.5px', fontWeight: '600' }}>Take Profit</span>{' '}
                      <span style={{ fontSize: '9.5px', opacity: '0.8' }}>{dc.t(m.tpHint)}</span>{' '}
                    </button>{' '}
                    {m.ordTpOn ? (
                      <>
                        {' '}
                        <div
                          style={{
                            padding: '8px 10px 9px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '6px',
                          }}
                        >
                          {' '}
                          <input
                            value={dc.v(m.ordTp)}
                            onChange={m.setOrdTp}
                            aria-label="Take profit price"
                            style={{
                              width: '100%',
                              boxSizing: 'border-box',
                              padding: '7px 11px',
                              borderRadius: '9px',
                              border: '1px solid var(--l10)',
                              background: 'var(--fill)',
                              color: 'var(--text)',
                              fontSize: '12.5px',
                              outline: 'none',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          />{' '}
                          <div style={{ display: 'flex', gap: '12px' }}>
                            {' '}
                            <span style={{ fontSize: '10px', color: 'var(--muted2)', flex: '1' }}>
                              {'Distance '}
                              <span style={{ color: 'var(--text2)', fontVariantNumeric: 'tabular-nums' }}>
                                {dc.t(m.tpDist)}
                              </span>
                            </span>{' '}
                            <span style={{ fontSize: '10px', color: 'var(--muted2)' }}>
                              {'Gain '}
                              <span
                                style={{
                                  color: 'var(--pos)',
                                  fontWeight: '600',
                                  fontVariantNumeric: 'tabular-nums',
                                }}
                              >
                                {dc.t(m.tpGain)}
                              </span>
                            </span>{' '}
                          </div>{' '}
                        </div>{' '}
                      </>
                    ) : null}{' '}
                  </div>{' '}
                </div>{' '}
                <div
                  style={{
                    border: '1px solid var(--l8)',
                    borderRadius: '11px',
                    background: 'var(--l3)',
                    padding: '10px 12px',
                  }}
                >
                  {' '}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '9px',
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                      color: 'var(--muted2)',
                      fontWeight: '600',
                    }}
                  >
                    <i className="ph ph-shield" style={{ fontSize: '11px' }}></i>Auto-calculated risk
                  </div>{' '}
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(3,1fr)',
                      gap: '8px',
                      marginTop: '9px',
                    }}
                  >
                    {' '}
                    <div>
                      <div
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        Risk
                      </div>
                      <div
                        style={dc.css(
                          `font-size:12.5px;font-weight:600;margin-top:2px;font-variant-numeric:tabular-nums;color:${dc.s(m.ordRiskFg)}`,
                        )}
                      >
                        {dc.t(m.ordRisk)}
                      </div>
                      <div
                        style={{
                          fontSize: '9.5px',
                          color: 'var(--muted2)',
                          marginTop: '1px',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(m.ordRiskPct)}
                      </div>
                    </div>{' '}
                    <div>
                      <div
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        Reward
                      </div>
                      <div
                        style={dc.css(
                          `font-size:12.5px;font-weight:600;margin-top:2px;font-variant-numeric:tabular-nums;color:${dc.s(m.ordRewardFg)}`,
                        )}
                      >
                        {dc.t(m.ordReward)}
                      </div>
                      <div
                        style={{
                          fontSize: '9.5px',
                          color: 'var(--muted2)',
                          marginTop: '1px',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(m.ordRewardPct)}
                      </div>
                    </div>{' '}
                    <div>
                      <div
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        R : R
                      </div>
                      <div
                        style={{
                          fontSize: '12.5px',
                          fontWeight: '600',
                          marginTop: '2px',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(m.ordRr)}
                      </div>
                      <div style={{ fontSize: '9.5px', color: 'var(--muted2)', marginTop: '1px' }}>
                        {dc.t(m.ordRrNote)}
                      </div>
                    </div>{' '}
                  </div>{' '}
                  <div
                    style={{
                      fontSize: '10px',
                      color: 'var(--muted2)',
                      marginTop: '9px',
                      paddingTop: '8px',
                      borderTop: '1px solid var(--l6)',
                      lineHeight: '1.5',
                    }}
                  >
                    {dc.t(m.ordRiskNote)}
                  </div>{' '}
                </div>{' '}
                <div>
                  {' '}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '9px',
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                      color: 'var(--muted2)',
                      fontWeight: '600',
                    }}
                  >
                    <i className="ph ph-lightning" style={{ fontSize: '11px' }}></i>Strategy
                  </div>{' '}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '7px',
                      padding: '8px 12px',
                      borderRadius: '9px',
                      border: '1px solid var(--l8)',
                      background: 'transparent',
                      fontSize: '11.5px',
                      color: 'var(--muted2)',
                      fontStyle: 'italic',
                    }}
                  >
                    {'No strategy / off-plan '}
                    <i className="ph ph-caret-down" style={{ fontSize: '11px' }}></i>
                  </div>{' '}
                </div>{' '}
                {m.ordHasErr ? (
                  <>
                    {' '}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '7px',
                        fontSize: '11px',
                        color: 'var(--neg)',
                        lineHeight: '1.5',
                      }}
                    >
                      <i
                        className="ph ph-warning-circle"
                        style={{ fontSize: '12px', marginTop: '1px', flex: 'none' }}
                      ></i>
                      {dc.t(m.ordErr)}
                    </div>{' '}
                  </>
                ) : null}{' '}
                <button
                  className="scp-cc1088e"
                  onClick={m.ordSubmit}
                  title="Review and submit this order"
                  aria-label={dc.a(m.ordBtnLabel)}
                  style={dc.css(
                    `display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:12px;border-radius:11px;border:1px solid ${dc.s(m.ordBtnBd)};background:${dc.s(m.ordBtnBg)};color:${dc.s(m.ordBtnFg)};font-size:12.5px;font-weight:700;letter-spacing:0.01em;cursor:pointer;opacity:${dc.s(m.ordBtnOp)};font-variant-numeric:tabular-nums`,
                  )}
                >
                  <i className={`ph ${dc.s(m.ordBtnIcon)}`} style={{ fontSize: '14px' }}></i>
                  {dc.t(m.ordBtnLabel)}
                </button>{' '}
              </div>{' '}
            </div>{' '}
          </>
        ) : null}{' '}
      </aside>
      <span hidden id="pf-desk-daterange-note">
        Desk rows in this build carry no dates to filter by — the dated Trades screen has the range filter.
        Activating this control means re-sourcing the desk tables from the dated ledger, which is with the
        owner as ESC-013.
      </span>
    </div>
  );
}
